import React, { StatelessComponent } from 'react';
import b from 'b_';

import './rect.css';

const class_ = b.with('rect');

interface RectProps {
    type?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
}

const Rect: StatelessComponent<RectProps> = ({ width, height, type = 'default', className }) => {
    const classes = className ? `${class_({ type })} ${className}` : class_({ type });

    return (
        <div style={{ width, height }} className={classes} />
    );
};

export default Rect;
